export const transcriptionProviders = Object.freeze([
  { value: 'deepgram', labelKey: 'deepgram' },
  { value: 'openai', labelKey: 'openai' },
])

export const transcriptionLanguages = Object.freeze([
  { value: 'en', labelKey: 'english' },
  { value: 'auto', labelKey: 'auto' },
  { value: 'zh', labelKey: 'chinese' },
  { value: 'ja', labelKey: 'japanese' },
  { value: 'ko', labelKey: 'korean' },
  { value: 'fr', labelKey: 'french' },
  { value: 'de', labelKey: 'german' },
  { value: 'es', labelKey: 'spanish' },
  { value: 'it', labelKey: 'italian' },
  { value: 'pt', labelKey: 'portuguese' },
  { value: 'ru', labelKey: 'russian' },
  { value: 'hi', labelKey: 'hindi' },
  { value: 'ar', labelKey: 'arabic' },
])

export function getDefaultTranscriptionLanguage(provider) {
  return provider === 'openai' ? 'auto' : 'en'
}

export function getAvailableTranscriptionLanguages(provider) {
  return provider === 'deepgram'
    ? transcriptionLanguages.filter(language => language.value !== 'auto')
    : transcriptionLanguages
}
